<div class="account-header">
  Manage your linked accounts below.
</div>
<div class="account-row">
  <span class="account-type">ConnectWise</span>
  <span class="account-button" *ngIf="!ssoConnected">
    <button mat-button type="button" color="primary" (click)="connectCwSso()">LINK ACCOUNT</button>
  </span>
  <span class="account-button" *ngIf="ssoConnected">
    <button mat-button type="button" color="primary" (click)="disconnectCwSso()" [disabled]="onlyHasCwSsoCreds">UNLINK ACCOUNT</button>
  </span>
</div>